<!-- EDI申込内容確認テーブル（共通） -->
<template>
  <v-simple-table dense>
    <tbody>
      <tr>
        <td class="font-weight-bold" style="width: 200px;">JWNET登録事業者名</td>
        <td>{{ formData.jwnet_name }}</td>
      </tr>
      <tr v-if="formData.emission_name">
        <td class="font-weight-bold">事業者名</td>
        <td>{{ formData.emission_name }}</td>
      </tr>
      <tr v-if="formData.emission_name_kana">
        <td class="font-weight-bold">事業者名（カナ）</td>
        <td>{{ formData.emission_name_kana }}</td>
      </tr>
      <tr v-if="formData.emission_location_name">
        <td class="font-weight-bold">事業所名</td>
        <td>{{ formData.emission_location_name }}</td>
      </tr>
      <tr v-if="formData.emission_location_name_kana">
        <td class="font-weight-bold">事業所名（カナ）</td>
        <td>{{ formData.emission_location_name_kana }}</td>
      </tr>
      <tr v-if="formData.representative_last_name || formData.representative_first_name">
        <td class="font-weight-bold">代表者名</td>
        <td>{{ displayRepresentativeName }}</td>
      </tr>
      <tr v-if="formData.representative_last_name_kana || formData.representative_first_name_kana">
        <td class="font-weight-bold">代表者名（カナ）</td>
        <td>{{ displayRepresentativeNameKana }}</td>
      </tr>
      <tr>
        <td class="font-weight-bold">郵便番号</td>
        <td>{{ formData.zip_code }}</td>
      </tr>
      <tr>
        <td class="font-weight-bold">住所</td>
        <td>{{ displayAddress }}</td>
      </tr>
      <tr v-if="formData.phone_number">
        <td class="font-weight-bold">電話番号</td>
        <td>{{ formData.phone_number }}</td>
      </tr>
      <tr v-if="formData.contact_last_name || formData.contact_first_name">
        <td class="font-weight-bold">ご担当者名</td>
        <td>{{ displayContactName }}</td>
      </tr>
      <tr v-if="formData.contact_last_name_kana || formData.contact_first_name_kana">
        <td class="font-weight-bold">ご担当者名（カナ）</td>
        <td>{{ displayContactNameKana }}</td>
      </tr>
      <tr v-if="formData.contact_phone_number">
        <td class="font-weight-bold">担当者電話番号</td>
        <td>{{ formData.contact_phone_number }}</td>
      </tr>
      <tr v-if="formData.email">
        <td class="font-weight-bold">メールアドレス</td>
        <td>{{ formData.email }}</td>
      </tr>
      <tr v-if="formData.industry_code">
        <td class="font-weight-bold">業種</td>
        <td>{{ displayIndustries }}</td>
      </tr>
      <tr v-if="formData.jwnet_pricing_type === 'c_plan_dxe' && formData.visibility_type">
        <td class="font-weight-bold">公開設定</td>
        <td>{{ displayPublicationType }}</td>
      </tr>
      <tr v-if="formData.visibility_type === 'name_and_profile' && formData.visibility_url">
        <td class="font-weight-bold">公開URL</td>
        <td>{{ formData.visibility_url }}</td>
      </tr>
      <tr v-if="formData.jwnet_pricing_type">
        <td class="font-weight-bold">JWNET料金区分</td>
        <td>{{ formData.jwnet_pricing_type | jwnet_pricing_type_label }}</td>
      </tr>
      <tr v-if="formData.subscriber_number">
        <td class="font-weight-bold">加入者番号</td>
        <td>{{ formData.subscriber_number }}</td>
      </tr>
      <tr v-if="formData.edi_usage_key">
        <td class="font-weight-bold">EDI利用確認キー</td>
        <td>{{ formData.edi_usage_key }}</td>
      </tr>
      <tr v-if="formData.transport_name">
        <td class="font-weight-bold">処理業者</td>
        <td>{{ formData.transport_name || '未設定' }}</td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import PrefectureList from '@/mixins/PrefectureList'

export default {
  name: 'EdiConfirmTable',
  mixins: [PrefectureList],
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  created() {
  },
  watch: {
  },
  data() {
    return {
      industriesList: [
        { label: '農業', value: 'A0100', category: 'agriculture_forestry_fisheries' },
        { label: '林業', value: 'B0200', category: 'agriculture_forestry_fisheries' },
        { label: '漁業（水産養殖業を除く）', value: 'B0300', category: 'agriculture_forestry_fisheries' },
        { label: '水産養殖業', value: 'B0400', category: 'agriculture_forestry_fisheries' },
        { label: '鉱業，採石業，砂利採取業', value: 'C0500', category: 'mining' },
        { label: '総合工事業', value: 'D0600', category: 'construction' },
        { label: '職別工事業（設備工事業を除く）', value: 'D0700', category: 'construction' },
        { label: '設備工事業', value: 'D0800', category: 'construction' },
        { label: '食料品製造業', value: 'E0900', category: 'manufacturing' },
        { label: '飲料・たばこ・飼料製造業', value: 'E1000', category: 'manufacturing' },
        { label: '繊維工業', value: 'E1100', category: 'manufacturing' },
        { label: '木材・木製品製造業（家具を除く）', value: 'E1200', category: 'manufacturing' },
        { label: '家具・装備品製造業', value: 'E1300', category: 'manufacturing' },
        { label: 'パルプ・紙・紙加工品製造業', value: 'E1400', category: 'manufacturing' },
        { label: '印刷・同関連業', value: 'E1500', category: 'manufacturing' },
        { label: '化学工業', value: 'E1600', category: 'manufacturing' },
        { label: '石油製品・石炭製品製造業', value: 'E1700', category: 'manufacturing' },
        { label: 'プラスチック製品製造業（別掲を除く）', value: 'E1800', category: 'manufacturing' },
        { label: 'ゴム製品製造業', value: 'E1900', category: 'manufacturing' },
        { label: 'なめし革・同製品・毛皮製造業', value: 'E2000', category: 'manufacturing' },
        { label: '窯業・土石製品製造業', value: 'E2100', category: 'manufacturing' },
        { label: '鉄鋼業', value: 'E2200', category: 'manufacturing' },
        { label: '非鉄金属製造業', value: 'E2300', category: 'manufacturing' },
        { label: '金属製品製造業', value: 'E2400', category: 'manufacturing' },
        { label: 'はん用機械器具製造業', value: 'E2500', category: 'manufacturing' },
        { label: '生産用機械器具製造業', value: 'E2600', category: 'manufacturing' },
        { label: '業務用機械器具製造業', value: 'E2700', category: 'manufacturing' },
        { label: '電子部品・デバイス・電子回路製造業', value: 'E2800', category: 'manufacturing' },
        { label: '電気機械器具製造業', value: 'E2900', category: 'manufacturing' },
        { label: '情報通信機械器具製造業', value: 'E3000', category: 'manufacturing' },
        { label: '輸送用機械器具製造業', value: 'E3100', category: 'manufacturing' },
        { label: 'その他の製造業', value: 'E3200', category: 'manufacturing' },
        { label: '電気業', value: 'F3300', category: 'electricity_gas_heat_water' },
        { label: 'ガス業', value: 'F3400', category: 'electricity_gas_heat_water' },
        { label: '熱供給業', value: 'F3500', category: 'electricity_gas_heat_water' },
        { label: '水道業', value: 'F3600', category: 'electricity_gas_heat_water' },
        { label: '通信業', value: 'G3700', category: 'information_communication' },
        { label: '放送業', value: 'G3800', category: 'information_communication' },
        { label: '情報サービス業', value: 'G3900', category: 'information_communication' },
        { label: 'インターネット附随サービス業', value: 'G4000', category: 'information_communication' },
        { label: '映像・音声・文字情報制作業', value: 'G4100', category: 'information_communication' },
        { label: '鉄道業', value: 'H4200', category: 'transport_postal' },
        { label: '道路旅客運送業', value: 'H4300', category: 'transport_postal' },
        { label: '道路貨物運送業', value: 'H4400', category: 'transport_postal' },
        { label: '水運業', value: 'H4500', category: 'transport_postal' },
        { label: '航空運輸業', value: 'H4600', category: 'transport_postal' },
        { label: '倉庫業', value: 'H4700', category: 'transport_postal' },
        { label: '運輸に附帯するサービス業', value: 'H4800', category: 'transport_postal' },
        { label: '郵便業（信書便事業を含む）', value: 'H4900', category: 'transport_postal' },
        { label: '各種商品卸売業', value: 'I5000', category: 'wholesale_retail' },
        { label: '繊維・衣服等卸売業', value: 'I5100', category: 'wholesale_retail' },
        { label: '飲食料品卸売業', value: 'I5200', category: 'wholesale_retail' },
        { label: '建築材料，鉱物・金属材料等卸売業', value: 'I5300', category: 'wholesale_retail' },
        { label: '機械器具卸売業', value: 'I5400', category: 'wholesale_retail' },
        { label: 'その他の卸売業', value: 'I5500', category: 'wholesale_retail' },
        { label: '各種商品小売業', value: 'I5600', category: 'wholesale_retail' },
        { label: '織物・衣服・身の回り品小売業', value: 'I5700', category: 'wholesale_retail' },
        { label: '飲食料品小売業', value: 'I5800', category: 'wholesale_retail' },
        { label: '機械器具小売業', value: 'I5900', category: 'wholesale_retail' },
        { label: 'その他の小売業', value: 'I6000', category: 'wholesale_retail' },
        { label: '無店舗小売業', value: 'I6100', category: 'wholesale_retail' },
        { label: '銀行業', value: 'J6200', category: 'finance_insurance' },
        { label: '協同組織金融業', value: 'J6300', category: 'finance_insurance' },
        { label: '貸金業，クレジットカード業等非預金信用機関', value: 'J6400', category: 'finance_insurance' },
        { label: '金融商品取引業，商品先物取引業', value: 'J6500', category: 'finance_insurance' },
        { label: '補助的金融業等', value: 'J6600', category: 'finance_insurance' },
        { label: '保険業（保険媒介代理業，保険サービス業を含む）', value: 'J6700', category: 'finance_insurance' },
        { label: '不動産取引業', value: 'K6800', category: 'real_estate_rental' },
        { label: '不動産賃貸業・管理業', value: 'K6900', category: 'real_estate_rental' },
        { label: '物品賃貸業', value: 'K7000', category: 'real_estate_rental' },
        { label: '学術・開発研究機関', value: 'L7100', category: 'academic_professional' },
        { label: '専門サービス業（他に分類されないもの）', value: 'L7200', category: 'academic_professional' },
        { label: '広告業', value: 'L7300', category: 'academic_professional' },
        { label: '技術サービス業（他に分類されないもの）', value: 'L7400', category: 'academic_professional' },
        { label: '宿泊業', value: 'M7500', category: 'accommodation_food' },
        { label: '飲食店', value: 'M7600', category: 'accommodation_food' },
        { label: '持ち帰り・配達飲食サービス業', value: 'M7700', category: 'accommodation_food' },
        { label: '洗濯・理容・美容・浴場業', value: 'N7800', category: 'lifestyle_entertainment' },
        { label: 'その他の生活関連サービス業', value: 'N7900', category: 'lifestyle_entertainment' },
        { label: '娯楽業', value: 'N8000', category: 'lifestyle_entertainment' },
        { label: '学校教育', value: 'O8100', category: 'education' },
        { label: 'その他の教育，学習支援業', value: 'O8200', category: 'education' },
        { label: '医療業', value: 'P8300', category: 'medical_welfare' },
        { label: '保健衛生', value: 'P8400', category: 'medical_welfare' },
        { label: '社会保険・社会福祉・介護事業', value: 'P8500', category: 'medical_welfare' },
        { label: '郵便局', value: 'Q8600', category: 'services' },
        { label: '協同組合（他に分類されないもの）', value: 'Q8700', category: 'services' },
        { label: '廃棄物処理業', value: 'R8800', category: 'services' },
        { label: '自動車整備業', value: 'R8900', category: 'services' },
        { label: '機械等修理業（別掲を除く）', value: 'R9000', category: 'services' },
        { label: '職業紹介・労働者派遣業', value: 'R9100', category: 'services' },
        { label: 'その他の事業サービス業', value: 'R9200', category: 'services' },
        { label: '政治・経済・文化団体', value: 'R9300', category: 'public_service' },
        { label: '宗教', value: 'R9400', category: 'public_service' },
        { label: 'その他のサービス業', value: 'R9500', category: 'others' },
        { label: '外国公務', value: 'S9600', category: 'public_service' },
        { label: '国家公務', value: 'S9700', category: 'public_service' },
        { label: '地方公務', value: 'S9800', category: 'public_service' }
      ]
    }
  },
  computed: {
    jwnetNameKana() {
      return `${this.formData.emission_name_kana || ''}　${this.formData.emission_location_name_kana || ''}`.trim()
    },
    displayRepresentativeName() {
      return `${this.formData.representative_last_name || ''} ${this.formData.representative_first_name || ''}`.trim()
    },
    displayRepresentativeNameKana() {
      return `${this.formData.representative_last_name_kana || ''} ${this.formData.representative_first_name_kana || ''}`.trim()
    },
    displayContactName() {
      return `${this.formData.contact_last_name || ''} ${this.formData.contact_first_name || ''}`.trim()
    },
    displayContactNameKana() {
      return `${this.formData.contact_last_name_kana || ''} ${this.formData.contact_first_name_kana || ''}`.trim()
    },
    displayAddress() {
      const prefecture = this.getPrefectureText(this.formData.prefecture_code)
      return `${prefecture}${this.formData.address_1 || ''}${this.formData.address_2 || ''}${this.formData.address_3 || ''}`
    },
    displayIndustries() {
      if (!this.formData.industry_code) return '未選択'
      const industry = this.industriesList.find(i => i.value === this.formData.industry_code)
      return industry ? industry.label : this.formData.industry_code
    },
    displayPublicationType() {
      const types = {
        'not_public': '公開を希望しません。',
        'name_only': '加入者名のみ公開を希望します。',
        'name_and_profile': '加入者名と、URLにて加入者情報の公開を希望します。'
      }
      return types[this.formData.visibility_type] || '未選択'
    }
  },
  methods: {
    getPrefectureText(code) {
      const pref = this.prefList.find(p => p.value == code)
      return pref ? pref.text : ''
    }
  }
}
</script>
